var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "openMultiplePeopleCaseItems" },
    [
      _c(
        "div",
        { ref: "openMultiplePeople_dialog_ui" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.showDialog,
                "close-on-click-modal": false,
                "show-close": false,
                "custom-class": "openMultiplePeople-dialog",
                top: _vm.matchPhoneMedia ? "10%" : "5%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showDialog = $event
                },
                close: _vm.onCloseHand,
              },
            },
            [
              _c(
                "div",
                {
                  ref: "openMultiplePeopleContainer",
                  staticClass:
                    "openMultiplePeople-container animate__animated animate__zoomIn animate__faster",
                },
                [
                  _c("div", { staticClass: "pic-item" }),
                  _c("div", {
                    staticClass: "close-btn",
                    on: { click: _vm.onCloseHand },
                  }),
                  _c("div", { staticClass: "send-goods-star" }),
                  _c("div", { staticClass: "send-goods-star2" }),
                  _c("div", { staticClass: "openMultiplePeopleItem-content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "openMultiplePeople-item flex flex-col flex-ver",
                      },
                      [
                        _c(
                          "div",
                          {
                            ref: "multiplePeople0",
                            staticClass:
                              "openMultiplePeople-topItem flex flex-center-1",
                          },
                          _vm._l(
                            _vm.case_opened_awards,
                            function (
                              case_opened_awards_item,
                              case_opened_awards_index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: case_opened_awards_index,
                                  staticClass:
                                    "openMultiplePeople-top-item flex flex-center-1",
                                  class:
                                    "lotteryCount" +
                                    _vm.case_opened_awards.length,
                                },
                                [
                                  _c("c-award", {
                                    staticClass: "openMultiplePeople-cwardItem",
                                    attrs: {
                                      is_show_text: _vm.matchPhoneMedia
                                        ? false
                                        : true,
                                      rarity: case_opened_awards_item.rarity,
                                      picture: case_opened_awards_item.itempic,
                                      name: case_opened_awards_item.itemname,
                                      price: case_opened_awards_item.price,
                                      width: "100%",
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                        _c(
                          "div",
                          {
                            ref: "multiplePeople1",
                            staticClass: "open-MultiplePeople-item",
                          },
                          [
                            _c("p-case-opening", {
                              ref: "multiplePeople_people_open_box",
                              staticClass: "case-opening-one-item",
                              attrs: {
                                isDefalut: false,
                                items: _vm.MultiplePeopleList,
                                award_opened_show: true,
                                isTransition:
                                  !_vm.is_jump_multiplePeople_animation,
                              },
                              on: { on_finished: _vm.on_multiplePeople_opened },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            ref: "multiplePeople2",
                            staticClass:
                              "open-MultiplePeople-ctrl-con flex flex-center-1",
                          },
                          [
                            _c("div", { staticClass: "block" }),
                            _c(
                              "div",
                              {
                                staticClass: "ctl-con-btns flex flex-center-1",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btnItem",
                                    on: { click: _vm.onMPCOpenAWardHandler },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.isAwardRunning
                                            ? "开奖中"
                                            : "查看开奖"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "jump-animate-con flex flex-ver" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "jump-animate" },
                                  [
                                    _c("i-switch", {
                                      attrs: {
                                        "false-color": "#14131d",
                                        "true-color": "#F5B844",
                                      },
                                      on: {
                                        "on-change":
                                          _vm.toggleMultiplePeopleAnimation,
                                      },
                                      model: {
                                        value:
                                          _vm.is_jump_multiplePeople_animation,
                                        callback: function ($$v) {
                                          _vm.is_jump_multiplePeople_animation =
                                            $$v
                                        },
                                        expression:
                                          "is_jump_multiplePeople_animation",
                                      },
                                    }),
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("动画"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "multiplePeople-items-1" }, [
                          _c(
                            "div",
                            {
                              ref: "multiplePeople3",
                              staticClass:
                                "multiplePeople-tab-items flex flex-ver",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "multiplePeople-tab-item",
                                  on: {
                                    click: function ($event) {
                                      _vm.currentMPCTabs = 1
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tabItem flex flex-center-1",
                                      class: {
                                        "tabItem-active":
                                          _vm.currentMPCTabs == 1,
                                      },
                                    },
                                    [_vm._v(" 合开名单 ")]
                                  ),
                                ]
                              ),
                              _vm.isOverShow
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "multiplePeople-tab-item",
                                      on: {
                                        click: function ($event) {
                                          _vm.currentMPCTabs = 2
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tabItem flex flex-center-1",
                                          class: {
                                            "tabItem-active":
                                              _vm.currentMPCTabs == 2,
                                          },
                                        },
                                        [_vm._v(" 获奖名单 ")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "multiplePeople-list-item-1",
                              style: {
                                height: _vm.conHeight,
                                maxHeight: _vm.conHeight,
                              },
                            },
                            [
                              _vm.currentMPCTabs == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "multiplePeople-list-item-item",
                                    },
                                    _vm._l(_vm.players, function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "listItem flex flex-col flex-ver",
                                        },
                                        [
                                          _c("el-avatar", {
                                            attrs: {
                                              size: "large",
                                              src: item.avatar,
                                            },
                                          }),
                                          _c("p", { staticClass: "name" }, [
                                            _vm._v(_vm._s(item.name)),
                                          ]),
                                          _c(
                                            "p",
                                            { staticClass: "contribution" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("conversion")(
                                                      item.amount
                                                    )
                                                  ) +
                                                  "(" +
                                                  _vm._s(item.ratio) +
                                                  "%) "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm.currentMPCTabs == 2
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "multiplePeople-list-item-item",
                                    },
                                    [
                                      _vm._l(
                                        _vm.players,
                                        function (item, index) {
                                          return [
                                            item.awardItems.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "listItem flex flex-col flex-ver",
                                                  },
                                                  [
                                                    _c("el-avatar", {
                                                      attrs: {
                                                        size: "large",
                                                        src: item.avatar,
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      { staticClass: "name" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("c-RewardModal", {
        ref: "mpcase_reward_ui",
        attrs: { isMyself: false },
        on: { onCloseRewardHandle: _vm.onCloseRewardHandle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }